//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
// defrag daily results card imports
import {
  ISurveyState,
  ISurveyProps,
  ICardState,
  ICardProps,
} from "./TailoredDefragSummaryActions.d";
import { styles } from "./TailoredDefragSummaryActions.styles";
// other components
import { CardButton } from "@components/card"; // material-ui
// material-ui
import { Button } from "@material-ui/core";
import { Check } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class TailoredDefragSummarySurveyActionsCmpt extends React.PureComponent<
  ISurveyProps,
  ISurveyState
> {
  constructor(props: ISurveyProps) {
    super(props);
  }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { selectedFeedback, onFeedbackSelect } = this.props;

    return (
      <div className={this.props.classes.footer}>
        <span className={this.props.classes.feedback}>Were these changes helpful?</span>
        <div className={this.props.classes.actions}>
          <Button
            classes={{
              root:
                selectedFeedback === "LooksGood"
                  ? this.props.classes.selectedActionButton
                  : this.props.classes.unselectedActionButton,
              label: this.props.classes.actionLabel,
            }}
            onClick={() => onFeedbackSelect("LooksGood" as ISchema.DefragFeedback)}
          >
            Yes
          </Button>
          <Button
            classes={{
              root:
                selectedFeedback === "Meh"
                  ? this.props.classes.selectedActionButton
                  : this.props.classes.unselectedActionButton,
              label: this.props.classes.actionLabel,
            }}
            onClick={() => onFeedbackSelect("Meh" as ISchema.DefragFeedback)}
          >
            No
          </Button>
          <Button
            classes={{
              root:
                selectedFeedback === "Maybe"
                  ? this.props.classes.selectedActionButton
                  : this.props.classes.unselectedActionButton,
              label: this.props.classes.actionLabel,
            }}
            onClick={() => onFeedbackSelect("Maybe" as ISchema.DefragFeedback)}
          >
            Not Sure
          </Button>
        </div>
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const TailoredDefragSummarySurveyActions = withStyles(styles)(
  TailoredDefragSummarySurveyActionsCmpt,
);

export class TailoredDefragSummaryCardActionCmpt extends React.PureComponent<
  ICardProps,
  ICardState
> {
  constructor(props: ICardProps) {
    super(props);
  }

  private onClick = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    return (
      <div className={this.props.classes.cardButtonContainer}>
        <CardButton flat onClick={this.onClick} icon={<Check />} label={"Got It"} />
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const TailoredDefragSummaryCardAction = withStyles(styles)(
  TailoredDefragSummaryCardActionCmpt,
);
